import { Link } from "react-router-dom";
import Layout from "../layout/Layout";
import SEO from "../Components/SEO/SEO";

export default function TermsOfService() {
  return (
    <Layout>
      <SEO
        title="Terms of Service | Quantum Spark Technology"
        description="Terms governing use of quantumsparktechnology.com and engagement with Quantum Spark Technology services."
        path="/terms"
      />
      <article className="mx-auto max-w-3xl px-6 py-16 md:py-24">
        <p className="mb-4 text-sm font-semibold uppercase tracking-widest text-brand-purple">Legal</p>
        <h1 className="mb-4 font-display text-4xl font-bold text-brand-ink md:text-5xl">Terms of Service</h1>
        <p className="mb-10 text-sm text-brand-muted">Last updated: August 16, 2026</p>

        <div className="space-y-8 text-base leading-relaxed text-brand-muted">
          <section>
            <h2 className="mb-3 font-display text-2xl font-bold text-brand-ink">1. Agreement</h2>
            <p>
              By accessing quantumsparktechnology.com or engaging Quantum Spark Technology for software development
              services, you agree to these Terms of Service. If you do not agree, do not use the site or our services.
            </p>
          </section>

          <section>
            <h2 className="mb-3 font-display text-2xl font-bold text-brand-ink">2. Services</h2>
            <p>
              We provide custom software design and development, including but not limited to websites, web applications,
              mobile apps, UI/UX design, AI feature integration, blockchain development, and quality assurance. Project
              scope, timeline, fees, and deliverables are defined in a written proposal, statement of work, or contract
              agreed by both parties. Website estimates and calculators are indicative only.
            </p>
          </section>

          <section>
            <h2 className="mb-3 font-display text-2xl font-bold text-brand-ink">3. Client responsibilities</h2>
            <ul className="list-disc space-y-2 pl-5">
              <li>Provide accurate requirements, content, and timely feedback</li>
              <li>Ensure you have rights to materials you supply (logos, copy, data, credentials)</li>
              <li>Designate a decision-maker for approvals and change requests</li>
              <li>Pay invoices according to the agreed schedule</li>
            </ul>
          </section>

          <section>
            <h2 className="mb-3 font-display text-2xl font-bold text-brand-ink">4. Intellectual property</h2>
            <p>
              Upon full payment of agreed fees, you receive ownership of custom code and deliverables created specifically
              for your project, excluding third-party libraries, open-source components, and our pre-existing tools,
              frameworks, and know-how. Open-source licenses continue to apply to those components. We may showcase
              completed work in our portfolio unless a written NDA or contract says otherwise.
            </p>
          </section>

          <section>
            <h2 className="mb-3 font-display text-2xl font-bold text-brand-ink">5. Acceptable use of the website</h2>
            <p>
              You may not misuse the site by attempting unauthorized access, scraping at abusive rates, distributing
              malware, or submitting fraudulent inquiries. We may suspend access for abuse or security risk.
            </p>
          </section>

          <section>
            <h2 className="mb-3 font-display text-2xl font-bold text-brand-ink">6. Warranties and disclaimers</h2>
            <p>
              The website is provided &ldquo;as is.&rdquo; We work to keep information accurate, but we do not guarantee
              uninterrupted availability or that all content is error-free. Project warranties, if any, are stated in the
              signed engagement documents and may include a limited post-launch support window.
            </p>
          </section>

          <section>
            <h2 className="mb-3 font-display text-2xl font-bold text-brand-ink">7. Limitation of liability</h2>
            <p>
              To the fullest extent permitted by law, Quantum Spark Technology is not liable for indirect, incidental,
              special, consequential, or punitive damages, or for lost profits or data, arising from use of the site or
              services. Our total liability for a project is limited to fees paid for that project in the three months
              preceding the claim, unless a signed contract states otherwise.
            </p>
          </section>

          <section>
            <h2 className="mb-3 font-display text-2xl font-bold text-brand-ink">8. Confidentiality</h2>
            <p>
              Both parties agree to protect confidential business information shared during evaluation or delivery and to
              use it only for performing the engagement, subject to any separate NDA.
            </p>
          </section>

          <section>
            <h2 className="mb-3 font-display text-2xl font-bold text-brand-ink">9. Termination</h2>
            <p>
              Either party may terminate an engagement as described in the applicable contract. Fees for work completed
              and non-cancellable third-party costs remain due. Website access terms may be updated or discontinued at
              our discretion.
            </p>
          </section>

          <section>
            <h2 className="mb-3 font-display text-2xl font-bold text-brand-ink">10. Governing law</h2>
            <p>
              These Terms are governed by the laws applicable in Pakistan, without regard to conflict-of-law rules,
              unless a signed client contract specifies a different governing law.
            </p>
          </section>

          <section>
            <h2 className="mb-3 font-display text-2xl font-bold text-brand-ink">11. Contact</h2>
            <p>
              Questions about these Terms:{" "}
              <a className="font-medium text-brand-purple hover:underline" href="mailto:info@quantumsparktechnology.com">
                info@quantumsparktechnology.com
              </a>
              . See also our{" "}
              <Link className="font-medium text-brand-purple hover:underline" to="/privacy">
                Privacy Policy
              </Link>
              .
            </p>
          </section>
        </div>
      </article>
    </Layout>
  );
}
